import { AutoPlayObjectType, RowDataItem } from 'app-types';
import { RelatedItem, PageHeader } from 'store-types';
import { parseRowData, parseVideo } from './kitchenSink';

export interface ParsedDataByTag {
  type: string;
  header: PageHeader | null;
  title: string;
  description: string;
  thumbnail: string;
  autoplay: string;
  autoplayObject?: ReturnType<typeof parseVideo>;
  rows: ReturnType<typeof parseRows>;
  relatedLeagues: RelatedItem[];
  relatedShows: RelatedItem[];
  relatedMarkets: RelatedItem[];
}

export interface DataByTagResponse {
  data: {
    type: string;
    header: PageHeader | null;
    title: string;
    description: string;
    thumbnail: string;
    autoplay: string;
    autoplayObject: AutoPlayObjectType;
    content: Array<{
      id: string;
      slug: string;
      type: string;
      title: string;
      description: string;
      url: string;
      layout: string;
      row: RowDataItem[];
    }>;
    relatedLeagues: RelatedItem[];
    relatedShows: RelatedItem[];
    relatedMarkets: RelatedItem[];
  };
}

export const parseDataByTag = (response: DataByTagResponse): ParsedDataByTag => {
  const {
    type,
    header,
    title,
    description,
    thumbnail,
    autoplay,
    autoplayObject,
    content,
    relatedLeagues,
    relatedShows,
    relatedMarkets,
  } = response.data;
  return {
    type,
    header,
    title,
    description,
    thumbnail,
    autoplay,
    autoplayObject: parseVideo(autoplayObject),
    rows: parseRows(content),
    relatedLeagues,
    relatedShows,
    relatedMarkets,
  };
};

const parseRows = (rows: DataByTagResponse['data']['content']) => {
  const getLayoutType = (layout: string): number => {
    switch (layout) {
      case 'oneacross':
      case 'one-across':
        return 1;
      case 'twoacross':
      case 'two-across':
        return 2;
      case 'threeacross':
      case 'three-cross':
      case 'threeAcrossHighlight':
        return 3;
      case 'fouracross':
      case 'four-across':
      case 'fourAcrossHighlight':
        return 4;
      case 'fiveacross':
      case 'five-across':
      default:
        return 5;
    }
  };

  return rows
    .map(({ id, slug, type, title, description, url, layout, row }) => {
      const parsed = parseRowData(row);

      if (!Array.isArray(parsed) || parsed.length === 0) {
        return null;
      }

      return {
        data: parsed,
        id,
        slug,
        type,
        title,
        description,
        url,
        layoutType: getLayoutType(layout),
      };
    })
    .filter(item => item !== null);
};
